
import OpenEngineerApi from '@/api/OpenEngineerApi';
import ModalImportDetail from './ModalImportDetail.vue'
import { isEmpty } from '@/utils/tool.util';
import { message } from 'ant-design-vue';
import { computed, defineComponent, reactive, ref } from 'vue';
import { Config } from '@/api/http';

const columns = [
  { title: 'Excel文件标题', dataIndex: 'title', ellipsis: true },
  { title: '对应系统中的字段', dataIndex: 'selectProperty', ellipsis: true }
];

export default defineComponent({
  components: {
    ModalImportDetail
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  setup (props, ctx) {
    const showModal = computed({
      get () {
        return props.visible
      },
      set (value) {
        ctx.emit('update:visible', value)
      }
    })
    const excel = ref() // 上传的文件名
    let titles: Array<any> = [] // 上传的Excel头部字段
    let datas: Array<any> = [] // 上传的Excel数据
    const options = ref<Array<any>>([]) // 系统对应的字段
    const titleOptions = ref<Array<any>>([]) // 列表渲染
    const update = ref(false) // 是否覆盖更新
    const hasComplete = ref(false) // 上传是否完成
    const importResult = reactive({ // 上传的结果
      recordId: 0,
      failureCount: 0,
      successCount: 0
    })
    const isLoading = ref(false)
    const detailVisible = ref(false)

    function handleDownloadTemplate () {
      window.open('/export_engineer_template?_token=' + Config._token);
    }
    function handleDownloadFailure () {
      window.open('/download_import_engineer_failure_record?recordId=' + importResult.recordId + '&_token=' + Config._token);
    }

    function handleDetail () {
      detailVisible.value = true
    }

    function handleUpload () {
      let input:HTMLInputElement | null = document.querySelector('#import-engineer-excel')
      if (input) {
        document.body.removeChild(input)
      }
      input = document.createElement('input')
      input.id = 'import-engineer-excel'
      input.type = 'file'
      input.style.display = 'none'
      input.onchange = function (e: any) {
        const file:File = e?.target?.files[0]
        if (file) {
          const formData = new FormData()
          formData.append('file', file)
          OpenEngineerApi.importEngineerExcel(formData).then(res => {
            excel.value = file
            titles = res.titles
            options.value = res.selectPropertyOptions
            datas = res.datas
            titleOptions.value = []
            for (let i = 0, len = titles.length; i < len; i++) {
              const titleOption:any = {
                title: titles[i],
                selectProperty: ''
              };
              const option = options.value.find(item => item.option === titles[i])
              titleOption.selectProperty = option ? option.value : ''
              titleOptions.value.push(titleOption)
            }
          })
        }
      }
      document.body.appendChild(input)
      input.click()
    }

    function handleOk () {
      const fields = titleOptions.value
      const vals:Array<string> = []
      for (let i = 0; i < fields.length; i++) {
        const val = fields[i].selectProperty;
        if (isEmpty(val)) {
          message.error("请选择完整!");
          return;
        }
        if (vals.indexOf(val) > -1) {
          message.error("选择重复!");
          return;
        }
        vals.push(val);
      }
      isLoading.value = true
      OpenEngineerApi.importEngineer(update.value, {
        titles,
        fileds: vals,
        selectPropertys: vals,
        datas: datas
      }).then(res => {
        hasComplete.value = true
        importResult.recordId = res.recordId
        importResult.failureCount = res.failureCount;
        importResult.successCount = res.successCount;
      }).finally(() => {
        isLoading.value = false
      })
    }

    function handleCancel () {
      showModal.value = false
      titleOptions.value = []
      excel.value = null
    }
    
    function handleFinish () { // 恢复默认
      showModal.value = false
      hasComplete.value = false
      excel.value = null
      titleOptions.value = []
    }

    return {
      columns,
      showModal,
      update,
      hasComplete,
      excel,
      options,
      titleOptions,
      importResult,
      isLoading,
      detailVisible,
      handleDownloadTemplate,
      handleDownloadFailure,
      handleDetail,
      handleUpload,
      handleOk,
      handleCancel,
      handleFinish
    }
  }
})
